var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('section',[_c('span',[_vm._v("404")]),_c('p',[_vm._v("The requested path could not be found")])])])}]

export { render, staticRenderFns }